module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-up.56b960b2.svg";